"use strict";
// THIS FILE IS GENERATED AUTOMATICALLY. DO NOT MODIFY.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = exports.txClient = exports.registry = exports.MissingWalletError = void 0;
const stargate_1 = require("@cosmjs/stargate");
const proto_signing_1 = require("@cosmjs/proto-signing");
const rest_1 = require("./rest");
const tx_1 = require("./types/nftmngr/tx");
const tx_2 = require("./types/nftmngr/tx");
const tx_3 = require("./types/nftmngr/tx");
const tx_4 = require("./types/nftmngr/tx");
const tx_5 = require("./types/nftmngr/tx");
const tx_6 = require("./types/nftmngr/tx");
const tx_7 = require("./types/nftmngr/tx");
const tx_8 = require("./types/nftmngr/tx");
const tx_9 = require("./types/nftmngr/tx");
const tx_10 = require("./types/nftmngr/tx");
const tx_11 = require("./types/nftmngr/tx");
const tx_12 = require("./types/nftmngr/tx");
const tx_13 = require("./types/nftmngr/tx");
const tx_14 = require("./types/nftmngr/tx");
const tx_15 = require("./types/nftmngr/tx");
const tx_16 = require("./types/nftmngr/tx");
const tx_17 = require("./types/nftmngr/tx");
const tx_18 = require("./types/nftmngr/tx");
const tx_19 = require("./types/nftmngr/tx");
const tx_20 = require("./types/nftmngr/tx");
const tx_21 = require("./types/nftmngr/tx");
const tx_22 = require("./types/nftmngr/tx");
const tx_23 = require("./types/nftmngr/tx");
const types = [
    ["/thesixnetwork.sixnft.nftmngr.MsgChangeSchemaOwner", tx_1.MsgChangeSchemaOwner],
    ["/thesixnetwork.sixnft.nftmngr.MsgCreateNFTSchema", tx_2.MsgCreateNFTSchema],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetMetadataFormat", tx_3.MsgSetMetadataFormat],
    ["/thesixnetwork.sixnft.nftmngr.MsgRemoveSystemActioner", tx_4.MsgRemoveSystemActioner],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetUriRetrievalMethod", tx_5.MsgSetUriRetrievalMethod],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetFeeConfig", tx_6.MsgSetFeeConfig],
    ["/thesixnetwork.sixnft.nftmngr.MsgResyncAttributes", tx_7.MsgResyncAttributes],
    ["/thesixnetwork.sixnft.nftmngr.MsgChangeOrgOwner", tx_8.MsgChangeOrgOwner],
    ["/thesixnetwork.sixnft.nftmngr.MsgAddSystemActioner", tx_9.MsgAddSystemActioner],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetMintauth", tx_10.MsgSetMintauth],
    ["/thesixnetwork.sixnft.nftmngr.MsgCreateMultiMetadata", tx_11.MsgCreateMultiMetadata],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetOriginChain", tx_12.MsgSetOriginChain],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetOriginContract", tx_13.MsgSetOriginContract],
    ["/thesixnetwork.sixnft.nftmngr.MsgShowAttributes", tx_14.MsgShowAttributes],
    ["/thesixnetwork.sixnft.nftmngr.MsgAddAction", tx_15.MsgAddAction],
    ["/thesixnetwork.sixnft.nftmngr.MsgAddAttribute", tx_16.MsgAddAttribute],
    ["/thesixnetwork.sixnft.nftmngr.MsgCreateMetadata", tx_17.MsgCreateMetadata],
    ["/thesixnetwork.sixnft.nftmngr.MsgToggleAction", tx_18.MsgToggleAction],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetBaseUri", tx_19.MsgSetBaseUri],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetNFTAttribute", tx_20.MsgSetNFTAttribute],
    ["/thesixnetwork.sixnft.nftmngr.MsgPerformMultiTokenAction", tx_21.MsgPerformMultiTokenAction],
    ["/thesixnetwork.sixnft.nftmngr.MsgSetAttributeOveriding", tx_22.MsgSetAttributeOveriding],
    ["/thesixnetwork.sixnft.nftmngr.MsgPerformActionByAdmin", tx_23.MsgPerformActionByAdmin],
];
exports.MissingWalletError = new Error("wallet is required");
exports.registry = new proto_signing_1.Registry(types);
const defaultFee = {
    amount: [],
    gas: "200000",
};
const txClient = (wallet, { addr: addr } = { addr: "http://localhost:26657" }, options) => __awaiter(void 0, void 0, void 0, function* () {
    if (!wallet)
        throw exports.MissingWalletError;
    let client;
    if (addr) {
        client = yield stargate_1.SigningStargateClient.connectWithSigner(addr, wallet, Object.assign({ registry: exports.registry }, options));
    }
    else {
        client = yield stargate_1.SigningStargateClient.offline(wallet, { registry: exports.registry });
    }
    const { address } = (yield wallet.getAccounts())[0];
    return {
        signAndBroadcast: (msgs, { fee, memo } = { fee: defaultFee, memo: "" }) => client.signAndBroadcast(address, msgs, fee, memo),
        msgChangeSchemaOwner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgChangeSchemaOwner", value: tx_1.MsgChangeSchemaOwner.fromPartial(data) }),
        msgCreateNFTSchema: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgCreateNFTSchema", value: tx_2.MsgCreateNFTSchema.fromPartial(data) }),
        msgSetMetadataFormat: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetMetadataFormat", value: tx_3.MsgSetMetadataFormat.fromPartial(data) }),
        msgRemoveSystemActioner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgRemoveSystemActioner", value: tx_4.MsgRemoveSystemActioner.fromPartial(data) }),
        msgSetUriRetrievalMethod: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetUriRetrievalMethod", value: tx_5.MsgSetUriRetrievalMethod.fromPartial(data) }),
        msgSetFeeConfig: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetFeeConfig", value: tx_6.MsgSetFeeConfig.fromPartial(data) }),
        msgResyncAttributes: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgResyncAttributes", value: tx_7.MsgResyncAttributes.fromPartial(data) }),
        msgChangeOrgOwner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgChangeOrgOwner", value: tx_8.MsgChangeOrgOwner.fromPartial(data) }),
        msgAddSystemActioner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgAddSystemActioner", value: tx_9.MsgAddSystemActioner.fromPartial(data) }),
        msgSetMintauth: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetMintauth", value: tx_10.MsgSetMintauth.fromPartial(data) }),
        msgCreateMultiMetadata: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgCreateMultiMetadata", value: tx_11.MsgCreateMultiMetadata.fromPartial(data) }),
        msgSetOriginChain: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetOriginChain", value: tx_12.MsgSetOriginChain.fromPartial(data) }),
        msgSetOriginContract: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetOriginContract", value: tx_13.MsgSetOriginContract.fromPartial(data) }),
        msgShowAttributes: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgShowAttributes", value: tx_14.MsgShowAttributes.fromPartial(data) }),
        msgAddAction: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgAddAction", value: tx_15.MsgAddAction.fromPartial(data) }),
        msgAddAttribute: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgAddAttribute", value: tx_16.MsgAddAttribute.fromPartial(data) }),
        msgCreateMetadata: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgCreateMetadata", value: tx_17.MsgCreateMetadata.fromPartial(data) }),
        msgToggleAction: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgToggleAction", value: tx_18.MsgToggleAction.fromPartial(data) }),
        msgSetBaseUri: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetBaseUri", value: tx_19.MsgSetBaseUri.fromPartial(data) }),
        msgSetNFTAttribute: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetNFTAttribute", value: tx_20.MsgSetNFTAttribute.fromPartial(data) }),
        msgPerformMultiTokenAction: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgPerformMultiTokenAction", value: tx_21.MsgPerformMultiTokenAction.fromPartial(data) }),
        msgSetAttributeOveriding: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgSetAttributeOveriding", value: tx_22.MsgSetAttributeOveriding.fromPartial(data) }),
        msgPerformActionByAdmin: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftmngr.MsgPerformActionByAdmin", value: tx_23.MsgPerformActionByAdmin.fromPartial(data) }),
    };
});
exports.txClient = txClient;
const queryClient = ({ addr: addr } = { addr: "http://localhost:1317" }) => __awaiter(void 0, void 0, void 0, function* () {
    return new rest_1.Api({ baseUrl: addr });
});
exports.queryClient = queryClient;
//# sourceMappingURL=index.js.map